"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutcodeSectors$ = exports.OutcodeSectors$outboundSchema = exports.OutcodeSectors$inboundSchema = void 0;
exports.outcodeSectorsToJSON = outcodeSectorsToJSON;
exports.outcodeSectorsFromJSON = outcodeSectorsFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const outcodesectorswrapper_js_1 = require("./outcodesectorswrapper.js");
/** @internal */
exports.OutcodeSectors$inboundSchema = z.object({
    data: outcodesectorswrapper_js_1.OutcodeSectorsWrapper$inboundSchema,
});
/** @internal */
exports.OutcodeSectors$outboundSchema = z.object({
    data: outcodesectorswrapper_js_1.OutcodeSectorsWrapper$outboundSchema,
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var OutcodeSectors$;
(function (OutcodeSectors$) {
    /** @deprecated use `OutcodeSectors$inboundSchema` instead. */
    OutcodeSectors$.inboundSchema = exports.OutcodeSectors$inboundSchema;
    /** @deprecated use `OutcodeSectors$outboundSchema` instead. */
    OutcodeSectors$.outboundSchema = exports.OutcodeSectors$outboundSchema;
})(OutcodeSectors$ || (exports.OutcodeSectors$ = OutcodeSectors$ = {}));
function outcodeSectorsToJSON(outcodeSectors) {
    return JSON.stringify(exports.OutcodeSectors$outboundSchema.parse(outcodeSectors));
}
function outcodeSectorsFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.OutcodeSectors$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'OutcodeSectors' from JSON`);
}
//# sourceMappingURL=outcodesectors.js.map